import request from '@/utils/request.js';
export const DayList = (params) => {
    return request.get('/api/todaysee',params)
  }

  export const GhList = (params) => {
    return request.get('/api/getreginfo',params)
  }